import React, { useState, useEffect, useRef } from 'react';
import Image from 'react-bootstrap/Image';
import logo from './assets/wowleads_black.png';
import { BrowserRouter as Router, Routes, Route, Link ,Navigate, useLocation} from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useNavigate } from "react-router-dom";

import "./App.scss";
import './App.css';

import MHome from './megaleads/mhome';
import Main from './components/main';
import Mmain from './megaleads/mmain';
import MyContent from './components/mycontent';
// import Pmain from './components/pmain';
// import Hmain from './components/hmain';
import SigninPage from './components/signin';
import SignupPage from './components/signup';
import axios from 'axios';
import LogoutOnUnload from './components/logoutonunload';
import CustomData from './components/customdata';
import AdminDashboard from './components/admindashboard';
// import EncryptPassword from './components/encryptpassword';
import ProfileDropdown from './components/profiledropdown';
import VerifyEmail from './components/verifyemail';
import ForgotPassword from './components/forgotpassword';
import ChangeUserPassword from './components/changeUserPassword';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import AccountDetails from './components/accountdetails';
import Pricing from './components/pricing';


import CampaignsMain from './campaigns/campaignsmain'
import SMTPCredentials from './campaigns/emailcampaign/smtpcredentials';
import EmailTemplates from './campaigns/emailcampaign/emailtemplates';
import Campaigns from './campaigns/formcampaign/campaigns';
import ContactFormTemplates from './campaigns/formcampaign/contactformtemplates';
import EmailCampaigns from './campaigns/emailcampaign/campaigns';
import MobileView from './components/mobileview';
import { getCookie, setCookie, eraseAllCookies, setDomainCookie, eraseAllDomainCookies } from './utils/cookieutils';
import NotFoundPage from './components/notfoundpage';
// import Campaigns from './campaigns/campaigns';
import InstagramTemplates from './campaigns/instagramcampaign/createtemplates';
import InstagramCampaignDetails from './campaigns/instagramcampaign/campaigndetails';
import DNDs from './components/dnds';
import JoyrideWrapper from './components/JoyrideWrapper';
import CategoryLandingPage from './components/categorylandingpage';
import CategoryGroups from './components/categorygroups';
import Agents from './campaigns/voicecampaign/agents';
import VoiceCampaigns from './campaigns/voicecampaign/voicecampaigns';
// import MyActivities from './components/myactivities';
import UserProfile from './components/userprofile';

const DEFAULT_ROUTE = '/mmain';
const MIN_SCREEN_WIDTH = 768;

function App() {
  const [mobile, setMobile] = useState(false); // useState(window.innerWidth < MIN_SCREEN_WIDTH);
  const [isLoggedIn, setIsLoggedIn] = useState(() => {return JSON.parse(sessionStorage.getItem('isLoggedIn')) || false});
  const [loggedInUser, setLoggedInUser] = useState(sessionStorage.getItem('email') || '');
  const [loggedInUserName, setLoggedInUserName] = useState(sessionStorage.getItem('username') || '');
  const [loggedInUserCountry, setLoggedInUserCountry] = useState(sessionStorage.getItem('usercountry') || '');
  const [loggedInUserId, setLoggedInUserId] = useState(getCookie('userid'));
  const [loggedInPlanId, setLoggedInPlanId] = useState(sessionStorage.getItem('planid') || -1);
  const [loggedInUserProfile, setLoggedInUserProfile] = useState(sessionStorage.getItem('userimg') === 'null' ? null : sessionStorage.getItem('userimg') || null);
  const [loggedInUserPlan, setLoggedInUserPlan] = useState(() => { return JSON.parse(sessionStorage.getItem('userplan')) || null });
  const [isProfileDropdownVisible, setIsProfileDropdownVisible] = useState(false);
  const [sessionId, setSessionId] = useState(sessionStorage.getItem('sessionid') || '');
  const [showSessionPopup, setShowSessionPopup] = useState(false);
  const [userData,setUserData]=useState(null)
  const navigate = useNavigate();
  const location = useLocation();
  const joyrideRef = useRef();
  const [isGuest, setIsGuest] = useState(parseInt(loggedInUserId) === 1  ? true : false);
   const isextensionlogin = 0;
  const [serverStatus, setServerStatus] = useState("up")

  const handleCallback = (bStatus, email, userid, planid, userimg, userplan, username, usercountry, session, userdata,token) => {
    setIsLoggedIn(bStatus);
    setLoggedInUser(email)
    setLoggedInUserId(userid);
    setLoggedInPlanId(planid);
    setLoggedInUserProfile(userimg);
    setLoggedInUserPlan(userplan);
    setLoggedInUserName(username);
    setLoggedInUserCountry(usercountry);
    setSessionId(session?.id)
    setUserData(userdata)

    sessionStorage.setItem('isLoggedIn', JSON.stringify(bStatus));
    sessionStorage.setItem('email', email);
    sessionStorage.setItem('userid', userid);
    sessionStorage.setItem('planid', planid);
    sessionStorage.setItem('userimg', userimg);
    sessionStorage.setItem('userplan', JSON.stringify(userplan));
    sessionStorage.setItem('username', username);
    sessionStorage.setItem('usercountry', usercountry);
    sessionStorage.setItem('sessionid', session?.id);
    sessionStorage.setItem('sessiontoken', token||'');
    sessionStorage.setItem('userdata', JSON.stringify(userdata));
    sessionStorage.setItem('isGuest', parseInt(userid) === 1  ? true : false);


    setCookie('userid', userid);
    setCookie('sessionid', session?.id);
    setCookie('sessiontoken', token||'');
    setDomainCookie('website-userid', userid, {
    days: 3650,
    path: '/',
    domain: '.wowleads.com',
    secure: true,
    sameSite: 'None'
    });
    setIsGuest(parseInt(userid) === 1  ? true : false);
    //localStorage.setItem('sessiontoken', session?.sessionToken);
    
    // const eventSource = initializeEventSource(userid, session?.id);
    // // Cleanup function
    // return () => {
    //   if (eventSource) eventSource.close();
    // };
  };

  // const initializeEventSource = (userId, sessionId) => {
  //   const eventSource = new EventSource(`${process.env.REACT_APP_WS_URL}/events?userId=${userId}&sessionId=${sessionId}`);
  
  //   eventSource.onmessage = (event) => {
  //     const eventData = JSON.parse(event.data);
  //     if (eventData.type === 'SESSION_INVALIDATED') {
  //       handleSessionInvalidation()
  //       setIsLoggedIn(false);
  //       if (eventSource) eventSource.close();
  //     }else if (eventData.type === 'ANOTHER_LOGIN') {
  //       handleSessionInvalidation()
  //       setIsLoggedIn(false);
  //       eraseAllCookies();
  //       sessionStorage.clear();
  //       if (eventSource) eventSource.close();
  //     }
  //   };
  
  //   return eventSource;
  // };

  //show graceful message when server is down

  // useEffect(()=>{
  //   const closeConnection = checkServerStatus();
  //   return closeConnection
  // },[]);

  useEffect(() => {
    // Disable right-click globally
    const handleContextMenu = (event) => {
      event.preventDefault();
    };
    
    document.addEventListener('contextmenu', handleContextMenu);

    return () => {
      // Clean up the event listener on unmount
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  const fetchData = async () => {
    try {
      let publicIP=''
      let ipInforesponse=''
      let ipInfo=''
      try{
        publicIP = await axios.get('https://api.ipify.org?format=json',{timeout: 2000});
        ipInforesponse = await axios.get(`/ipInfo/${publicIP.data.ip}`);
        ipInfo = ipInforesponse.data;
      }
      catch(exc){
        console.log(exc)
        ipInfo={ipInfo:{ip:'',country:'',loc:''},userAGInfo :{browser:'',os:''}}
      }
      const userdata = await axios.get(`/user/${loggedInUserId}`);
      const response = await axios.post('/validatesession', { loggedInUserId, sessionId, ipInfo, isextensionlogin });

      if (response.status === 206) {
        // User not found, show Session popup
        setShowSessionPopup(true);
        return;
      }

      if (response.statusText === "OK") {
        const userPlan = {
          id: userdata.data[0].planid,
          plan: userdata.data[0].plan,
          maxparallelcrawls: userdata.data[0].maxparallelcrawls,
          maxunmaskedleads: userdata.data[0].maxunmaskedleads,
          maxleadsperlist: userdata.data[0].maxleadsperlist,
          mailverificationkey: userdata.data[0].mailverificationkey,
          iskeywords: userdata.data[0].iskeywords,
          userid: loggedInUserId,
          usercountry: userdata.data[0].country,
          userage: userdata.data[0].userage
        };

        setCookie('sessionid', response.data.id);
        setCookie('sessiontoken', response.data.sessionToken);
        const udata = {
          isformcampaigns : userdata.data[0].isformcampaigns,
          isemailcampaigns : userdata.data[0].isemailcampaigns,
          isinstagramcampaigns : userdata.data[0].isinstagramcampaigns

        }
      
        localStorage.setItem('sessionid', response.data.id);
        //localStorage.setItem('sessiontoken', response.data.sessionToken);

        sessionStorage.setItem('sessionid', response.data.id);
        sessionStorage.setItem('sessiontoken', response.data.sessionToken);
        sessionStorage.setItem('isLoggedIn', true);
        sessionStorage.setItem('email', userdata.data[0].email);
        sessionStorage.setItem('userid', loggedInUserId);
        sessionStorage.setItem('planid', userdata.data[0].planid);
        sessionStorage.setItem('userimg', null);
        sessionStorage.setItem('userplan', JSON.stringify(userPlan));
        sessionStorage.setItem('username', userdata.data[0].firstname);
        sessionStorage.setItem('usercountry', userdata.data[0].country);
        sessionStorage.setItem('userdata', JSON.stringify(udata));
        sessionStorage.setItem('isGuest', parseInt(loggedInUserId) === 1  ? true : false);
        sessionStorage.setItem('jwttoken', response.data.token);
        
        setIsLoggedIn(true);
        setLoggedInUser(userdata.data[0].email);
        setLoggedInUserName(userdata.data[0].firstname);
        setLoggedInUserCountry(userdata.data[0].country);
        setLoggedInUserId(loggedInUserId);
        setUserData(udata)
        // setisformcampaigns(userdata.data[0].isformcampaigns)
        setLoggedInPlanId(userdata.data[0].planid);
        setLoggedInUserProfile(getCookie('userimg') === 'null' ? null : getCookie('userimg'));
        setLoggedInUserPlan(userPlan);
        setSessionId(response.data.id);
        setIsGuest(parseInt(loggedInUserId) === 1  ? true : false);

        if(loggedInUserId === 1) {
          setCookie("userid", loggedInUserId)
          sessionStorage.setItem('jwttoken', response.data.token);
        }
        // const eventSource = initializeEventSource(loggedInUserId, sessionId);
        if (location.pathname === "/pricing" || location.pathname.startsWith("/catalogsummary") || location.pathname === "/mmain/businesses" || location.pathname === "/mmain/people"  || location.pathname.startsWith("/categorysummary")) {
          navigate(location.pathname + location.search); 
        }else{
          const search = location.search; // this gives ?scg=automotive&country=US
          if (search) {
            navigate(`${DEFAULT_ROUTE}${search}`, { replace: true });
          } else {
            navigate(DEFAULT_ROUTE, { replace: true });
          }
        }
        // // Cleanup function
        // return () => {
        //   if (eventSource) eventSource.close();
        // };
        
      } else {
        setIsLoggedIn(false);
        eraseAllCookies();
        eraseAllDomainCookies({ path: "/", domain: ".wowleads.com" });
        sessionStorage.clear();
      }
    } catch (error) {
      setIsLoggedIn(false);
    }
  };

  useEffect(() => {
    const loggedInUserId = getCookie("userid");
    if (loggedInUserId) {    
      if(sessionStorage.getItem('sessionid') === null){
        fetchData();
        }//else if(sessionStorage.getItem('sessionid') !== getCookie('sessionid')){
      //    handleSessionInvalidation()
      // }
      else{
        setIsLoggedIn(true);
        setLoggedInUser(sessionStorage.getItem('email'))
        setLoggedInUserId(sessionStorage.getItem('userid'));
        setLoggedInPlanId(sessionStorage.getItem('planid'));
        setLoggedInUserProfile(null);
        setLoggedInUserPlan(() => { return JSON.parse(sessionStorage.getItem('userplan'))});
        setLoggedInUserName(sessionStorage.getItem('username'));
        setLoggedInUserCountry(sessionStorage.getItem('usercountry'));
        setSessionId(sessionStorage.getItem('sessionid'))
        setUserData(() => { return JSON.parse(sessionStorage.getItem('userdata'))})
      }
    }else if (!isLoggedIn && (location.pathname === "/mmain" || location.pathname === "/" || location.pathname === "/mmain/businesses" || location.pathname === "/mmain/people") && !isGuest) {
      setIsGuest(true);
      setLoggedInUserId(1);
    }
    
  }, []);

  useEffect(() => {
    if (isGuest && loggedInUserId === 1) {
      fetchData();
    }
  }, [isGuest, loggedInUserId]);

  // window.addEventListener('storage', (event) => {
  //   if (event.key === 'sessiontoken') {
  //       const currentSessionId = sessionStorage.getItem('sessiontoken');
  //       const newActiveSessionId = event.newValue;
  //       if (currentSessionId !== newActiveSessionId) {
  //           // The session has been invalidated
  //           handleSessionInvalidation();
  //       }
  //   }
  // });

  useEffect(() => {
      (async () => {
        try {
          const publicIP = await axios.get('https://api.ipify.org?format=json');
          const ipInforesponse = await axios.get(`/ipInfo/${publicIP.data.ip}`);
          const ipInfo = await ipInforesponse.data;
          const ip =ipInfo.ipInfo.ip;
          const country = ipInfo.ipInfo.country;
          const location = ipInfo.ipInfo.loc;
          const [latitude, longitude] = location.split(',').map(coord => coord.trim());
          const browser = ipInfo.userAGInfo.browser.name;
          const os = ipInfo.userAGInfo.os.name;
          const response = await axios.post('/getUserVisits', {ip, country, latitude, longitude, browser, os});
        } catch (err) {
          console.log("Error", err);
        }
      })();
    }, []);

  function handleSessionInvalidation() {
  

      setShowSessionPopup(true);
  }

  const handleWindowSizeChange = () => {
   // setMobile(window.innerWidth < MIN_SCREEN_WIDTH);
  }
  
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  const toggleLogin = async () => {
    if (isLoggedIn) {
      try {
        const response = await axios.post('/logout', { sessionid: sessionId })
        if (response.data.success) {
          setIsLoggedIn(false);
          setLoggedInUser(null);
          setLoggedInUserId(null);
          setLoggedInPlanId(null);
          setLoggedInUserProfile(null);
          setLoggedInUserPlan(null);
          setLoggedInUserName(null);
          setLoggedInUserCountry(null);
          setSessionId(null);
          setUserData(null)
          sessionStorage.clear();
          eraseAllCookies();
          eraseAllDomainCookies({ path: "/", domain: ".wowleads.com" });
          localStorage.clear();
        }
        else {
          console.error('Logout API request failed', response.data.error);
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  const renderTooltip = props => (
    <Tooltip className='shadow' {...props}>Account</Tooltip>
  );
  
  const toggleProfileDropdown = (e) => {
    e?.preventDefault()
    setIsProfileDropdownVisible(!isProfileDropdownVisible);
  }

  const handleCreateNewSession = async () => {
    const publicIP = await axios.get('https://api.ipify.org?format=json');
    const ipInforesponse = await axios.get(`/ipInfo/${publicIP.data.ip}`);
    const ipInfo = ipInforesponse.data;
    const userdata = await axios.get(`/user/${loggedInUserId}`);
    const sessionId = getCookie('sessionid');
    const response = await axios.post('/createnewsession', { loggedInUserId, ipInfo, planid : userdata.data[0].planid, isextensionlogin:isextensionlogin });
    
    if (response.statusText === "OK") {
      const userPlan = {
        id: userdata.data[0].planid,
        plan: userdata.data[0].plan,
        maxparallelcrawls: userdata.data[0].maxparallelcrawls,
        maxunmaskedleads: userdata.data[0].maxunmaskedleads,
        maxleadsperlist: userdata.data[0].maxleadsperlist,
        mailverificationkey: userdata.data[0].mailverificationkey,
        iskeywords: userdata.data[0].iskeywords,
        userid: loggedInUserId,
        usercountry: userdata.data[0].country,
        userage: userdata.data[0].userage
      };

      setCookie('sessionid', response.data.id);
      setCookie('sessiontoken', response.data.sessionToken);
      const udata = {
        isformcampaigns : userdata.data[0].isformcampaigns,
        isemailcampaigns : userdata.data[0].isemailcampaigns,
        isinstagramcampaigns : userdata.data[0].isinstagramcampaigns
      }
      localStorage.setItem('sessionid', response.data.id);
      //localStorage.setItem('sessiontoken', response.data.sessionToken);
      sessionStorage.setItem('sessionid', response.data.id);
      sessionStorage.setItem('sessiontoken', response.data.sessionToken);
      sessionStorage.setItem('isLoggedIn', true);
      sessionStorage.setItem('email', userdata.data[0].email);
      sessionStorage.setItem('userid', loggedInUserId);
      sessionStorage.setItem('planid', userdata.data[0].planid);
      sessionStorage.setItem('userimg', null);
      sessionStorage.setItem('userplan', JSON.stringify(userPlan));
      sessionStorage.setItem('username', userdata.data[0].firstname);
      sessionStorage.setItem('usercountry', userdata.data[0].country);
      sessionStorage.setItem('userdata', JSON.stringify(udata));
      sessionStorage.setItem('isGuest', parseInt(loggedInUserId) === 1  ? true : false);
      sessionStorage.setItem('jwttoken', response.data.token);

      setIsLoggedIn(true);
      setLoggedInUser(userdata.data[0].email);
      setLoggedInUserName(userdata.data[0].firstname);
      setLoggedInUserCountry(userdata.data[0].country);
      setLoggedInUserId(loggedInUserId);
      setLoggedInPlanId(userdata.data[0].planid);
      setLoggedInUserProfile(getCookie('userimg') === 'null' ? null : getCookie('userimg'));
      setLoggedInUserPlan(userPlan);
      setSessionId(response.data.id);
      setShowSessionPopup(false);
      setUserData(udata)
      setIsGuest(parseInt(loggedInUserId) === 1  ? true : false);
      // const eventSource = initializeEventSource(loggedInUserId, sessionId);
      if (location.pathname === "/pricing" || location.pathname.startsWith("/catalogsummary") || location.pathname === "/mmain/businesses" || location.pathname === "/mmain/people" || location.pathname.startsWith("/categorysummary")) {
        navigate(location.pathname + location.search); 
      }else{
        const search = location.search; // this gives ?scg=automotive&country=US
        if (search) {
          navigate(`${DEFAULT_ROUTE}${search}`, { replace: true });
        } else {
          navigate(DEFAULT_ROUTE, { replace: true });
        }
      }
      // // Cleanup function
      // return () => {
      //   if (eventSource) eventSource.close();
      // };
      
    }
};

const handleCancelClick = () => {
  setShowSessionPopup(false)
  window.location.href = 'https://wowleads.com/';
};

// const checkServerStatus = () =>{
//    try{
//         const ws = new WebSocket('ws://localhost:5000')
//         ws.onopen = () => setServerStatus("up");
//         //  ws.onmessage=(event)=>console.log("Message from server:", event.data)
//         ws.onclose = () => setServerStatus("down");
//         ws.onerror = () => setServerStatus("down");
//         return () => ws.close();
//    }
//    catch(error){
//        setServerStatus("down")
//    }
// }

  return (
    <div className="App">
        <header className="App-header">
          <Navbar collapseOnSelect expand="md" className="p-1 m-0 text-dark position-asolute" style={{backgroundColor: "var(--bg-wowleads)"}}>
            <Navbar.Brand className='p-0 mx-1 w-lg-nav-brand d-flex justify-content-center' style={{ border: "none", boxShadow: "none" }} >
              <Link to={'https://wowleads.com/'} >
                <Image src={logo} width="144" alt="WowLeads" style={{ border: "none", boxShadow: "none" }} />
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" className="ms-auto" style={{ border: "none", boxShadow: "none" }} />
            <Container fluid className="p-0 pe-1">
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto fs-fluid" >
                  <Nav.Link href="https://wowleads.com/index.html" rel="noopener noreferrer" className={`m-0 p-0`}>
                    <div className="nav-link">
                      Home
                    </div>
                  </Nav.Link>
                  {((loggedInUserPlan?.id === 1)) ? (
                  <Nav.Link href="#" className="m-0 p-0">
                    <Link to={'/mhome'} state={{ tab: 0 }}className={`nav-link ${isLoggedIn && serverStatus==="up" ? 'd-block' : 'd-none'}`}>
                      Ask AI
                    </Link>
                  </Nav.Link>
                  ) : ''}
                  <Nav.Link href="#" className="m-0 p-0">
                    <Link to={'/mmain'} state={{ tab: 0 }}className={`nav-link ${isLoggedIn && serverStatus==="up" ? 'd-block' : 'd-none'}`}>
                      Catalog
                    </Link>
                  </Nav.Link>
                  <Nav.Link href="#" className="m-0 p-0">
                    <Link to={'/mmain/businesses'} state={{ tab: 1 }}className={`nav-link ${isLoggedIn && serverStatus==="up" ? 'd-block' : 'd-none'}`}>
                      Find Businesses
                    </Link>
                  </Nav.Link>
                  <Nav.Link href="#" className="m-0 p-0">
                    <Link to={'/mmain/people'} state={{ tab: 2 }} className={`nav-link ${isLoggedIn && serverStatus==="up" ? 'd-block' : 'd-none'}`}>
                      Find People
                    </Link>
                  </Nav.Link>
                  <Nav.Link href="#" className="m-0 p-0">
                    <Link to={'/mycontent'} className={`nav-link ${isLoggedIn && serverStatus==="up" ? 'd-block' : 'd-none'}`}>
                      My Content
                    </Link>
                  </Nav.Link>
                   {/* <Nav.Link href="#" className="m-0 p-0">
                    <Link to={'/myactivities'} className={`nav-link ${isLoggedIn && serverStatus==="up" ? 'd-block' : 'd-none'}`}>
                      My Activities
                    </Link>
                  </Nav.Link> */}
                  {((loggedInUserPlan?.id === 1)) ? (
                  <Nav.Link href="#" className="m-0 p-0">
                    <Link to={'/main'} className={`nav-link ${isLoggedIn && serverStatus==="up" ? 'd-block' : 'd-none'}`}>
                      Live Crawl
                    </Link>
                  </Nav.Link>
                 ) : ''}
                  {(loggedInUserPlan?.id === 1||(userData?.isformcampaigns==1||userData?.isemailcampaigns==1 ||userData?.isinstagramcampaigns==1)) ? (
                  <Nav.Link href="#" className="m-0 p-0">
                    <Link to={'/campaigns'} className={`nav-link ${isLoggedIn && serverStatus==="up" ? 'd-block' : 'd-none'}`}>
                      Campaigns
                    </Link>
                  </Nav.Link>
                  ) : ''}
                </Nav>
                <Nav className="justify-content-end m-0 fs-fluid">
                  <Nav.Link href="https://wowleads.com/index.html#Tutorial" target="_blank" rel="noopener noreferrer" className={`m-0 p-0`}>
                    <div className="nav-link">
                      Tutorial 
                    </div>
                  </Nav.Link>
                  <Nav.Link href="#" className={`m-0 p-0`}>
                    <Link to={'/pricing'} className="nav-link">
                      Pricing
                    </Link>
                  </Nav.Link>
                  <Nav.Link href="https://wowleads.com/index.html#Contact" target="_blank" rel="noopener noreferrer" className={`m-0 p-0`}>
                    <div className="nav-link">  
                      {isGuest ? "Book a Demo" : "Contact"}
                    </div>
                  </Nav.Link>
                  <Nav.Link href="#" className={`m-0 p-0 ${isLoggedIn && loggedInUserId !== 1 && serverStatus==="up" ? 'd-none' : 'd-block'}`}>
                    <Link to={'/signup'} className="nav-link">
                      {isLoggedIn && loggedInUserId !== 1 ? '' : 'Free Sign Up'}
                    </Link>
                  </Nav.Link>
                  <Nav.Link href="#" className={`m-0 p-0 ${isLoggedIn && loggedInUserId !== 1 && serverStatus==="up" ? 'd-none' : 'd-block'}`}>
                    <Link to={'/signin'} className="nav-link" onClick={toggleLogin}>
                      {isLoggedIn && loggedInUserId !== 1 ? '' : 'Sign In'}
                    </Link>
                  </Nav.Link>
                </Nav>
                <Nav className="justify-content-end fs-6">
                  <Nav.Link href="#" className={`m-0 p-0 my-1 ms-sm-2`}>
                    <Link to={`/customdata`} style={{ width: 36 }} className={`px-0 btn btn-primary ${isLoggedIn && (loggedInUserPlan.id === 1) && (serverStatus === "up") ? 'd-block' : 'd-none'}`}>
                      <i className={`bi bi-table`}></i>
                    </Link>
                  </Nav.Link>
                  <Nav.Link href="#" className={`m-0 p-0 my-1 ms-sm-2`}>
                    <Link to={`/adminPanel`} style={{ width: 36 }} className={`px-0 btn btn-primary ${isLoggedIn && (loggedInUserPlan.id === 1) && (serverStatus === "up") ? 'd-block' : 'd-none'}`}>
                      <i className={`bi bi-sliders`}></i>
                    </Link>
                  </Nav.Link>
                  <Nav.Link className={`m-0 p-0 my-1 ms-sm-2`}>
                    <OverlayTrigger placement="bottom" overlay={renderTooltip}>
                      <Link id='profile-icon' className={`${isLoggedIn && serverStatus==="up" ? 'd-block' : 'd-none'} ${loggedInUserProfile ? '' : 'btn btn-sm rounded-circle btn-primary d-flex align-items-center justify-content-center'}`} 
                      onClick={toggleProfileDropdown} style={{ height: 36, width: 36, alignSelf: "center" }}
                      >
                        {isLoggedIn ? (
                          loggedInUserProfile ? (
                            <img src={loggedInUserProfile} alt={loggedInUser.substring(0, 1).toUpperCase()} className="profile-img" style={{ height: 36, width: 36, objectFit: 'fill', borderRadius: '50%' }} />
                          ) : (
                            <span className='fs-5 shadow fw-medium'>{loggedInUserName.substring(0, 1).toUpperCase()}</span>
                          )
                        ) : ''}
                      </Link>
                    </OverlayTrigger>
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>

              {isProfileDropdownVisible && (
                <ProfileDropdown email={loggedInUser} onLogout={toggleLogin} closeDropdown={toggleProfileDropdown} loggedInUserId={loggedInUserId} loggedInUserPlan={loggedInUserPlan} loggedInUserName={loggedInUserName} loggedInUserCountry={loggedInUserCountry} loggedInUserProfile={loggedInUserProfile} joyrideRef={joyrideRef} />
              )}
            </Container>
          </Navbar>
        </header>
        {showSessionPopup ? (
          <Modal show={showSessionPopup} onHide={() => setShowSessionPopup(false)} centered size='md'>
          <Modal.Header closeButton={true}>
            <h6 className='mb-0 fw-semibold'>Wowleads</h6>
          </Modal.Header>
          <Modal.Body>
            <div>
                <label>
                  You have reached the limit of active sessions. Do you want to close all other sessions and open a new one?
                </label>
              <div className='mt-2 d-flex justify-content-end'>
              <Button onClick={handleCancelClick} className='btn-sm me-2' variant="secondary">
                Cancel
              </Button>
              <Button
                onClick={handleCreateNewSession}
                className={`btn-sm`}
                variant="primary"
              >
                Proceed
              </Button>
            </div>
            
            </div>
          </Modal.Body>
        </Modal>
      ) : ( serverStatus === "up" ?
        (<Container fluid className="p-0 m-0">
          <div className={`wrapper main-panel`}>
            <Routes>
              <Route
                exact
                path="/mhome"
                element={isLoggedIn && !isGuest ? 
                  <>
                   {mobile ? 
                    <MobileView />
                  :
                    <>
                    <LogoutOnUnload sessionid={sessionId} />
                    <MHome uid={loggedInUserId} plid={loggedInPlanId} plan={loggedInUserPlan} />
                    </>
                  }
                  </>
                  :
                  <SigninPage parentCallback={handleCallback} />}
              />
              <Route
                exact
                path="/"
                element={
                  isLoggedIn || isGuest ? 
                    <Navigate to="/mmain" replace /> 
                  : getCookie('userid') ? 
                    <>
                    {mobile ? 
                      <MobileView />
                    :
                      <>
                        <LogoutOnUnload sessionid={sessionId} /> 
                        <div className='loader-overlay'>
                          <div className="loader-container">
                            <img src="loader.gif" alt="Loading..." className="loader-image" />
                            <div className='fs-1 w-100 text-center'>Welcome to WowLeads</div>
                          </div>
                        </div>
                      </>
                    }
                    </>
                  : 
                    <SigninPage parentCallback={handleCallback} />
                  }
              />
              <Route
                exact
                path="/signup"
                element={
                  isLoggedIn && !isGuest ? 
                    <>
                    {mobile ? 
                      <MobileView />
                    : 
                      <>
                      <LogoutOnUnload sessionid={sessionId} />
                      <Mmain uid={loggedInUserId} ucountry={loggedInUserCountry} plid={loggedInPlanId} plan={loggedInUserPlan} joyrideRef={joyrideRef} />
                      </>
                    }
                    </>
                  :
                    <SignupPage parentCallback={handleCallback} />
                  }
              />
              <Route
                exact
                path="/signin"
                element={
                  isLoggedIn && !isGuest ? 
                    <>
                    {mobile ? 
                      <MobileView />
                    :
                      <>
                      <LogoutOnUnload sessionid={sessionId} />
                      <Mmain uid={loggedInUserId} ucountry={loggedInUserCountry} plid={loggedInPlanId} plan={loggedInUserPlan} joyrideRef={joyrideRef} />
                      </>
                    }
                    </>
                  :
                    <SigninPage parentCallback={handleCallback} />
                  }
              />
              <Route
                exact
                path="/mmain"
                element={isLoggedIn ? 
                  <Mmain uid={loggedInUserId} ucountry={loggedInUserCountry} plid={loggedInPlanId} plan={loggedInUserPlan} joyrideRef={joyrideRef} />
                 :
                  <>
                  <LogoutOnUnload sessionid={sessionId} /> 
                  <div className='loader-overlay'>
                    <div className="loader-container">
                      <img src="loader.gif" alt="Loading..." className="loader-image" />
                      <div className='fs-1 w-100 text-center'>Welcome to WowLeads</div>
                    </div>
                  </div>
                </>
                }
              />
              <Route
                exact
                path="/mmain/businesses"
                element={isLoggedIn ? 
                  <Mmain uid={loggedInUserId} ucountry={loggedInUserCountry} plid={loggedInPlanId} plan={loggedInUserPlan} joyrideRef={joyrideRef} />
                 :
                  <>
                  <LogoutOnUnload sessionid={sessionId} /> 
                  <div className='loader-overlay'>
                    <div className="loader-container">
                      <img src={`${process.env.REACT_APP_URL}/loader.gif`} alt="Loading..." className="loader-image" />
                      <div className='fs-1 w-100 text-center'>Welcome to WowLeads</div>
                    </div>
                  </div>
                </>
                }
              />
              <Route
                exact
                path="/mmain/people"
                element={isLoggedIn ? 
                  <Mmain uid={loggedInUserId} ucountry={loggedInUserCountry} plid={loggedInPlanId} plan={loggedInUserPlan} joyrideRef={joyrideRef} />
                 :
                  <>
                  <LogoutOnUnload sessionid={sessionId} /> 
                  <div className='loader-overlay'>
                    <div className="loader-container">
                      <img src={`${process.env.REACT_APP_URL}/loader.gif`} alt="Loading..." className="loader-image" />
                      <div className='fs-1 w-100 text-center'>Welcome to WowLeads</div>
                    </div>
                  </div>
                </>
                }
              />
              <Route
                exact
                path="/main"
                element={isLoggedIn && !isGuest ? 
                  <>
                   {mobile ? 
                    <MobileView />
                  :
                    <>
                    <LogoutOnUnload sessionid={sessionId} />
                    <Main uid={loggedInUserId} plid={loggedInPlanId} plan={loggedInUserPlan} />
                    </>
                  }
                  </>
                  :
                  <SigninPage parentCallback={handleCallback} />}
              />
              <Route
                exact
                path="/mycontent"
                element={isLoggedIn && !isGuest ? 
                  <>
                   {mobile ? 
                    <MobileView />
                  :
                    <>
                      <LogoutOnUnload sessionid={sessionId} />
                      <MyContent uid={loggedInUserId} plid={loggedInPlanId} plan={loggedInUserPlan} />
                    </>
                  }
                  </>
                  :
                  <SigninPage parentCallback={handleCallback} />}
              />
              <Route
                exact
                path="/campaigns"
                element={isLoggedIn && !isGuest ? 
                  <>
                  {mobile ? 
                    <MobileView />
                  :
                    <>
                      <LogoutOnUnload sessionid={sessionId} />
                      <CampaignsMain loggedInUserPlan={loggedInUserPlan} user={userData}/> 
                    </>
                  } 
                  </>
                    :
                    <SigninPage parentCallback={handleCallback} />
                  }
              >
                
                <Route path="/campaigns" element={ isLoggedIn  && !isGuest ? 
                  <>
                    {mobile ? <MobileView /> : <Navigate to="/campaigns/form-campaigns" />} 
                  </>
                  :
                    <SigninPage parentCallback={handleCallback} />
                  }
                />
                <Route path="/campaigns/form-campaigns" element={ isLoggedIn && !isGuest ? 
                  <>{mobile ? <MobileView /> : <Campaigns uid={loggedInUserId}/>} </>
                  :
                    <SigninPage parentCallback={handleCallback} />
                  }/>
                <Route path="/campaigns/form-templates" element={ isLoggedIn && !isGuest ? 
                  <>{mobile ? <MobileView /> : <ContactFormTemplates uid={loggedInUserId}/>} </>
                  :
                    <SigninPage parentCallback={handleCallback} />
                  }/>
                <Route path="/campaigns/smtp-credentials" element={isLoggedIn && !isGuest ? 
                  <> {mobile ? <MobileView /> : <SMTPCredentials uid={loggedInUserId}/>} </>
                  :
                    <SigninPage parentCallback={handleCallback} />
                  }/>
                <Route path="/campaigns/mail-templates" element={ isLoggedIn && !isGuest ? 
                  <>{mobile ? <MobileView /> : <EmailTemplates uid={loggedInUserId}/>} </>
                  :
                    <SigninPage parentCallback={handleCallback} />
                  }/>
                <Route 
                  path="/campaigns/email-campaigns" 
                  element={ isLoggedIn && !isGuest ? 
                  <>{mobile ? <MobileView /> : <EmailCampaigns uid={loggedInUserId}/>} </>
                  :
                    <SigninPage parentCallback={handleCallback} />
                  }/>
                  <Route 
                  path="/campaigns/mail-templates/:campaignid" 
                  element={ isLoggedIn && !isGuest ? 
                  <>{mobile ? <MobileView /> : <EmailTemplates uid={loggedInUserId}/>} </>
                  :
                    <SigninPage parentCallback={handleCallback} />
                  }/>
                  <Route path="/campaigns/instagram-templates" element={ isLoggedIn && !isGuest ? 
                  <>{mobile ? <MobileView /> : <InstagramTemplates uid={loggedInUserId}/>} </>
                  :
                    <SigninPage parentCallback={handleCallback} />
                  }/>
                  <Route path="/campaigns/instagramcampaigns" element={ isLoggedIn && !isGuest ? 
                  <>{mobile ? <MobileView /> : <InstagramCampaignDetails uid={loggedInUserId}/>} </>
                  :
                    <SigninPage parentCallback={handleCallback} />
                  }/>
                  <Route path="/campaigns/dnds" element={ isLoggedIn && !isGuest ? 
                  <>{mobile ? <MobileView /> : <DNDs uid={loggedInUserId}/>} </>
                  :
                    <SigninPage parentCallback={handleCallback} />
                  }/>
                  <Route path="/campaigns/voice-agents" element={ isLoggedIn && !isGuest ? 
                  <>{mobile ? <MobileView /> : <Agents uid={loggedInUserId} loggedInUserName={loggedInUserName}/>} </>
                  :
                    <SigninPage parentCallback={handleCallback} />
                  }/>
                  <Route path="/campaigns/voice-campaigns" element={ isLoggedIn && !isGuest ? 
                  <>{mobile ? <MobileView /> : <VoiceCampaigns uid={loggedInUserId}/>} </>
                  :
                    <SigninPage parentCallback={handleCallback} />
                  }/>
              </Route>
              <Route
                exact
                path="/customdata"
                element={isLoggedIn && (loggedInUserPlan.id === 1) && !isGuest ? 
                  <>
                    {mobile ? 
                      <MobileView />
                    :
                    <>
                      <LogoutOnUnload sessionid={sessionId}/> 
                      <CustomData loggedInUserId={loggedInUserId} sessionid = {sessionId} />
                    </>
                    } 
                  </>
                  :
                  <SigninPage parentCallback={handleCallback} />
                }
              />
              <Route
                exact
                path="/adminPanel"
                element={isLoggedIn && (loggedInUserPlan.id === 1) && !isGuest ? 
                  <>
                    {mobile ? 
                      <MobileView />
                    :
                    <>
                      <LogoutOnUnload sessionid={sessionId}/> 
                      <AdminDashboard loggedInUserId={loggedInUserId} sessionid = {sessionId} />
                    </>
                    } 
                  </>
                  :
                  <SigninPage parentCallback={handleCallback} />
                }
              />
              <Route
                exact
                path="/profile"
                element={isLoggedIn && !isGuest ? 
                  <>
                    {mobile ? 
                      <MobileView />
                    :
                    <>
                      <LogoutOnUnload sessionid={sessionId}/>
                      <UserProfile  loggedInUserId={loggedInUserId} sessionid = {sessionId} />  
                    </>
                    } 
                  </>
                  :
                  <SigninPage parentCallback={handleCallback} />
                }
              />
              <Route
                exact
                path="/verifyEmail"
                element={ mobile ? <MobileView /> : <VerifyEmail />}
              />
              <Route
                exact
                path="/forgotPassword"
                element={ mobile ? <MobileView /> : <ForgotPassword />}
              />
              <Route
                exact
                path="/changePassword"
                element={
                  <>
                    { mobile ? <MobileView /> : <ChangeUserPassword />}
                  </>
                }
              />
              <Route
                exact
                path="/accountdetails"
                element={isLoggedIn && !isGuest ? 
                <>
                  {mobile ? 
                    <MobileView />
                  :
                  <>
                    <LogoutOnUnload sessionid={sessionId} />
                    <AccountDetails loggedInUserId={loggedInUserId}/> 
                  </>
                  } 
                </>
                  :
                  <SigninPage parentCallback={handleCallback} />
                }
              />
              <Route
                exact
                path="/pricing"
                element={<Pricing />}
              />
               <Route
                exact
                path="/catalogsummary"
                element={<CategoryLandingPage plan={loggedInUserPlan} />}
              />
              <Route
                exact
                path="/categorysummary"
                element={<CategoryGroups />}
              />

              {/* <Route
                exact
                path="/myactivities"
                element={ <MyActivities />}
              />
               */}
              {/* Catch-all route for undefined paths */}
              <Route path='*' element={<NotFoundPage />} />
            </Routes>
          </div>
        </Container>): serverStatus==="down" ? (
        <Container
          fluid
          className="d-flex flex-column justify-content-center align-items-center text-center my-5 py-5"
          style={{
            color: "#333",
          }}
        >
            <i class="bi bi-cloud-arrow-down-fill" style={{
              fontSize: "clamp(90px, 10vw, 500px)", 
              opacity: 0.3,
              marginBottom: "20px"
            }}></i>

            <h2 className="fw-semibold mb-3">
              Server is temporarily unavailable. We'll be back soon.
            </h2>

            <p className="text-muted" style={{ maxWidth: 500, fontSize: "1.05rem" }}>
              We're working quickly to resolve the issue and we're sorry for the delay.
              Please try again later.
            </p>

            <h4 className="mt-4 fw-bold">Thanks for your patience!</h4>
       </Container>): (
                    <div className='loader-overlay'>
                    <div className="loader-container">
                      <img src="/loader.gif" alt="Loading..." className="loader-image" />
                      <div className='fs-1 w-100 text-center'>Welcome to WowLeads</div>
                    </div>
                  </div>))
      }  
      <JoyrideWrapper ref={joyrideRef} />
    </div>
  )
}

export default App;
